import { useTemplate } from "PFApp/hooks";
import { Activity } from "PFCore/types";
import { useTranslation } from "react-i18next";

export const useTranslatedActivityType = (activity: Activity) => {
  const template = useTemplate(activity?.template_id);

  const { t } = useTranslation("activities", { keyPrefix: "templates" });
  return template ? t(template.key) : null;
};
